import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityMessage } from "../../entity/EntityMessage";

export class DtoMessagesGetRes extends EntityMessage {
  public items: EntityMessage[]  = [];
}
